import type { FetcherAxiosInstance } from '../fetcher';

export const createRecommendationsApi = (Fetcher: FetcherAxiosInstance) => ({
  fetchRecommendations: ({
    slots,
    categoryId,
    productIds,
    withCatalogProducts,
    type = 'cms',
  }) => Fetcher.get(`/recommendations/${type}`, {
    params: {
      slots,
      categoryId,
      productIds,
      withCatalogProducts,
    },
  }),
});
